import { getUserAdminData } from "./adminData";
import api from "./api";
import firebase from "./firebaseConfig";

export const isAuthenticated = async () => {
  return !firebase.auth().currentUser !== null;
};

export const getCompanyCurrentUser = async ({ onError } = {}) => {
  const user = firebase.auth().currentUser;

  if (!user) {
    return null;
  }

  try {
    const userAdminData = await getUserAdminData(user.email);

    if (userAdminData && userAdminData?.company_id) {
      return {
        id: userAdminData?.company_id,
        parentCompanyID: userAdminData?.parent_company_id,
        name: userAdminData?.company_name,
      };
    }

    return null;
  } catch (error) {
    const status = error?.response?.status;

    if (status !== 403 && status !== 404) {
      console.error("Failed to fetch user company:", error);
      onError?.(error);
    }

    return null;
  }
};

export const getUserPermissions = async () => {
  const defaultResponse = {
    permissions: {},
    initialRoutePath: null,
    permissionGuideUrl: null,
    resourcePolicies: [],
    featureFlags: {},
  };

  try {
    const { data } = await api.get("/auth/permissions");

    if (data?.permissions) {
      const objPermissions = {};
      data.permissions.forEach((p) => (objPermissions[p] = true));

      return {
        permissions: objPermissions,
        initialRoutePath: data?.initialRoutePath ?? null,
        permissionGuideUrl: data?.permissionGuideUrl ?? null,
        resourcePolicies: data?.resourcePolicies ?? [],
        featureFlags: data?.featureFlags ?? {},
      };
    }

    return defaultResponse;
  } catch (error) {
    return defaultResponse;
  }
};
